import { createContext, useContext } from "react";


export const AccountEmbeddedContext = createContext(false);
export const useAccountEmbedded = () => useContext(AccountEmbeddedContext);
